import React from "react";
import { SEARCH_TABS } from "../../../core/theme/searchTheme";

// "Search" (one scan, typed in) or "Upload CSV" (many scans from a file).
export default function SearchTabs({ mode, setMode }) {
  const tab = (id, label) => (
    <button type="button" className={mode === id ? SEARCH_TABS.tabActive : SEARCH_TABS.tab} onClick={() => setMode(id)}>
      {label}
    </button>
  );
  return (
    <div className={SEARCH_TABS.row}>
      {tab("search", "Search")}
      {tab("csv", "Upload CSV")}
    </div>
  );
}
